import { useMemo } from "react";

import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";

import { useSearchParameters } from ".";

export type UserSegJiraTemplateRedesign = {
    userSegmentationEnrollmentPreconditionsMet: boolean;
};

/**
 * useUserSegJiraTemplateRedesign
 *
 * Hook that determines to enroll a user into ATLAS_58859
 * @returns object
 */
export function useUserSegJiraTemplateRedesign(
    availableProducts: AvailableProductsResponse | null
): UserSegJiraTemplateRedesign {
    const { products, n2n, templateId } = useSearchParameters();
    const userSegmentationEnrollmentPreconditionsMet = useMemo(() => {
        let canN2EView = false;
        try {
            const isProvisioningOnlyJSW =
                products.length === 1 &&
                products[0] === "jira-software.ondemand";

            if (
                n2n === false &&
                isProvisioningOnlyJSW &&
                products.length === 1
            ) {
                // TODO: Move logic to allow existing non jira customers to view this screen to the jira screen configuration
                const jiraSites =
                    availableProducts?.sites?.filter((site) =>
                        site.products.includes("jira-software.ondemand")
                    ) ?? [];

                // N2E users should see user seg if they do not have Jira
                canN2EView = jiraSites.length === 0;
            }
        } catch (error) {
            console.log(error);
        }

        const hasTemplateRecommendation = Boolean(templateId);
        const isProvisioningOnlyJSW =
            products.length === 1 && products[0] === "jira-software.ondemand";
        return (
            !hasTemplateRecommendation &&
            isProvisioningOnlyJSW &&
            (n2n || canN2EView)
        );
    }, [templateId, products, n2n]);

    return {
        userSegmentationEnrollmentPreconditionsMet
    };
}
